<template>
	<div class="docs-list">
		<a v-for="(docsItem, index) in docsItems" :key="index" :href="docsItem.src" class="docs-list__item" :class="{'docs-list__item--dark' : dark}" :title="`Скачать ${docsItem.name}`" target="_blank">
			<span class="docs-list__item-name">{{ docsItem.name }}</span>
		</a>
	</div>
</template>

<script>
export default {
	name: "DocsList",
	props: {
		docsItems: {
			type: Array,
			default: () => []
		},
		dark: {
			type: Boolean,
			default: false
		}
	},
}
</script>

